<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="_title">
          <v-icon small>
            mdi-magnify
          </v-icon>
          DSR Viewer
        </div>
      </v-col>
    </v-row>
    <progress-linear :active="loading"></progress-linear>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>Tranaction Information</v-card-title>
          <div class="box">
            <v-row>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span>{{ this.$t('owlview.system') }}</span></v-col>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span>{{ this.$t('owlview.instance') }}</span></v-col>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span>{{ this.$t('owlview.node') }}</span></v-col>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span>{{ this.$t('owlview.userId') }}</span></v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field :value="selectedStep.sstmId" class="text-full-width" outlined dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field :value="selectedStep.instId" class="text-full-width" outlined dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field :value="selectedStep.nodeId" class="text-full-width" outlined dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field :value="selectedStep.userid" class="text-full-width" outlined dense hide-details readonly></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>DSR List</v-card-title>
          <div class="box">
            <v-data-table v-model="selectedSteps" :headers="stepHeaders" :items="steps" item-key="key" @click:row="highlight" height="150" class="elevation-0 content" dense hide-default-footer single-select fixed-header>
              <template v-slot:item.starttime="{ value }">{{ value | format('yyyy-MM-dd HH:mm:ss') }}</template>
              <template v-slot:item.actiontype="{ value }">{{ value.label }}</template>
              <template v-slot:item.servicetype="{ value }">{{ value.label }}</template>
              <template v-slot:item.resptime="{ value }">{{ value | comma }}</template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>DSR Information</v-card-title>
          <div class="box">
            <v-row :class="color(4)">
              <v-col cols="2">
                <p class="text-right">{{ selectedStep.sectionTimes.reduce((acc, value) => acc + value, 0) | comma }}</p>
              </v-col>
              <v-col cols="10">
                <section-time-bar :items="selectedStep.sectionTimes" :colors="sectionColors" :titles="sectionTitles"></section-time-bar>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card elevation="0" class="mt-2">
                  <v-tabs v-model="activeTab" height="35" slider-size="3" :background-color="color(3)" class="rounded-0" show-arrows>
                    <v-tab v-if="tabInfo.main">Main</v-tab>
                    <v-tab v-if="tabInfo.passport">Passport</v-tab>
                    <v-tab v-if="tabInfo.external">External</v-tab>
                    <v-tab-item v-if="tabInfo.main" transition="false" reverse-transition="false">
                      <main-tab :step="selectedStep"></main-tab>
                    </v-tab-item>
                    <v-tab-item v-if="tabInfo.passport" transition="false" reverse-transition="false" eager>
                      <passport-tab :step="selectedStep"></passport-tab>
                    </v-tab-item>
                    <v-tab-item v-if="tabInfo.external" transition="false" reverse-transition="false" eager>
                      <external-tab :step="selectedStep"></external-tab>
                    </v-tab-item>
                  </v-tabs>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MainTab from './MainTab';
import PassportTab from './PassportTab';
import ExternalTab from './ExternalTab';
import { api } from '../../../api/common/instances';

export default {
  components: {
    MainTab,
    PassportTab,
    ExternalTab,
  },
  data() {
    return {
      /* SSR List */
      steps: [],
      // 테이블이 single-select 이더라도 veutify의 data-table의 v-model은
      // 무조건 array를 원하므로 어쩔 수 없어 array를 사용해야 함.
      selectedSteps: [],
      selectedStep: { sectionTimes: [] },
      // selectedStepSectionTimes: [],
      /* Tab 정보 */
      tabInfo: {},
      activeTabCount: 0,
      /* 기타 */
      loading: false,
      sectionColors: ['#0000FF', '#FF33FF', '#33CCFF'],
      sectionTitles: ['CPU', 'DB', 'External'],
      activeTab: 0,
    };
  },
  computed: {
    ...mapState('analysis/dsr', ['loadingCount']),
    stepHeaders() {
      return [
        { text: this.$t('owlview.begin'), value: 'starttime', sortable: false, width: '24%' },
        { text: this.$t('owlview.protocol'), value: 'actiontype', sortable: false, width: '10%' },
        { text: this.$t('owlview.service.type'), value: 'servicetype', sortable: false, width: '15%' },
        { text: this.$t('owlview.action'), value: 'action', sortable: false, width: '41%' },
        { text: 'R.T.', value: 'resptime', sortable: false, width: '10%' },
      ];
    },
  },
  watch: {
    async selectedSteps(value) {
      this.selectedStep = value[0];
      this.selectedStepSectionTimes = this.selectedStep.sectionTimes;

      const { data: tabs } = await api.get('/analysis/dsrviewer/detail/count', {
        params: {
          svrYmdhms: this.selectedStep.svrYmdhms,
          sstmId: this.selectedStep.sstmId,
          instId: this.selectedStep.instId,
          nodeId: this.selectedStep.nodeId,
          transid: this.selectedStep.transid,
        },
      });
      this.tabInfo = tabs.reduce((acc, tab) => {
        acc[tab.tableName] = tab.count > 0;
        return acc;
      }, {});
      this.activeTabCount = Object.values(this.tabInfo).reduce((acc, value) => (value ? acc + 1 : acc), 0);
    },
    loadingCount(value) {
      if (value === this.activeTabCount) {
        this.loading = false;
        this.resetLoadingCount();
      } else if (value > 0) {
        this.loading = true;
      }
    },
  },
  async created() {
    // 최초 로딩 시에는 무조건 로딩바를 출력
    this.loading = true;

    /* dsr list */
    ({ data: this.steps } = await api.get('/analysis/dsrviewer/step', {
      params: {
        svrYmdhms: this.$route.query.dt,
        sstmId: this.$route.query.sid,
        instId: this.$route.query.iid,
        nodeId: this.$route.query.nid,
        transid: this.$route.query.trx,
      },
    }));
    // 최초 로딩 시에는 첫번째 행이 선택 되도록...
    this.selectedStep = this.steps[0];
    this.selectedStep.isSelected = true;
    this.selectedSteps.push(this.selectedStep);
  },
  methods: {
    ...mapActions('analysis/dsr', ['resetLoadingCount']),
    color(saturation) {
      return this.$vuetify.theme.isDark ? `grey darken-${saturation}` : `grey lighten-${saturation - 2}`;
    },
    highlight(item, { isSelected, select }) {
      // 같은 row를 클릭했을 때는 선택이 풀리지 않도록 리턴...
      if (item.key === this.selectedStep.key) {
        return;
      }
      select(!isSelected);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px 10px 10px;
}
._title {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2;
}
.text-full-width {
  width: auto;
}
</style>
